import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
let Address$1 = class Address {
  constructor({
    address,
    city,
    postalCode,
    country,
    state,
    additionalAddress
  }) {
    this.address = address || '';
    this.city = city || '';
    this.postalCode = postalCode || '';
    this.country = country || '';
    this.state = state || '';
    this.additionalAddress = additionalAddress || '';
  }
};
let LinkedIn$1 = class LinkedIn {
  constructor({
    publicProfileId
  }) {
    this.publicProfileId = publicProfileId || '';
  }
};
let User$1 = class User {
  constructor({
    userId,
    partnerId,
    email,
    roles,
    created,
    updated,
    firstName,
    greetingName,
    lastName,
    languageCode,
    publicKeys,
    lastLogin,
    emailVerified,
    phoneNumbers,
    address,
    profileImageUrl,
    timeZone,
    linkedIn,
    meetingBookingUrl
  }) {
    this.userId = userId || '';
    this.partnerId = partnerId || '';
    this.email = email || '';
    this.roles = roles || {};
    this.created = created || null;
    this.updated = updated || null;
    this.firstName = firstName || '';
    this.greetingName = greetingName || '';
    this.lastName = lastName || '';
    this.languageCode = languageCode || '';
    this.publicKeys = publicKeys || [];
    this.lastLogin = lastLogin || null;
    this.emailVerified = emailVerified || false;
    this.phoneNumbers = phoneNumbers || [];
    this.address = address || new Address$1({});
    this.profileImageUrl = profileImageUrl || '';
    this.timeZone = timeZone || '';
    this.linkedIn = linkedIn || new LinkedIn$1({});
    this.meetingBookingUrl = meetingBookingUrl || '';
  }
};
class Role {
  constructor({
    roleId,
    attributes,
    created,
    updated
  }) {
    this.roleId = roleId || '';
    this.attributes = attributes || null;
    this.created = created || null;
    this.updated = updated || null;
  }
}
var AlgorithmType$1 = /*#__PURE__*/function (AlgorithmType) {
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_ES256"] = 0] = "ALGORITHM_TYPE_ES256";
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_RS256"] = 1] = "ALGORITHM_TYPE_RS256";
  return AlgorithmType;
}(AlgorithmType$1 || {});
let PublicKey$1 = class PublicKey {
  constructor({
    key,
    id,
    algorithmType
  }) {
    this.key = key || '';
    this.id = id || '';
    this.algorithmType = algorithmType || AlgorithmType$1.ALGORITHM_TYPE_ES256;
  }
};
var PhoneNumberType$1 = /*#__PURE__*/function (PhoneNumberType) {
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_INVALID"] = 0] = "PHONE_NUMBER_TYPE_INVALID";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_WORK"] = 1] = "PHONE_NUMBER_TYPE_WORK";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_HOME"] = 2] = "PHONE_NUMBER_TYPE_HOME";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_MOBILE"] = 3] = "PHONE_NUMBER_TYPE_MOBILE";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_FAX"] = 4] = "PHONE_NUMBER_TYPE_FAX";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_PAGER"] = 5] = "PHONE_NUMBER_TYPE_PAGER";
  return PhoneNumberType;
}(PhoneNumberType$1 || {});
let PhoneNumber$1 = class PhoneNumber {
  constructor({
    phoneNumber,
    phoneNumberType
  }) {
    this.phoneNumber = phoneNumber || '';
    this.phoneNumberType = phoneNumberType || PhoneNumberType$1.PHONE_NUMBER_TYPE_INVALID;
  }
};
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    if (proto.intAttribute) {
      m.intAttribute = parseInt(proto.intAttribute, 10);
    }
    if (proto.structAttribute) {
      m.structAttribute = StructAttribute.fromProto(proto.structAttribute);
    }
    if (proto.listAttribute) {
      m.listAttribute = ListAttribute.fromProto(proto.listAttribute);
    }
    if (proto.timestampAttribute) {
      m.timestampAttribute = new Date(proto.timestampAttribute);
    }
    if (proto.geopointAttribute) {
      m.geopointAttribute = GeoPointAttribute.fromProto(proto.geopointAttribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.intAttribute !== 'undefined') {
      toReturn['intAttribute'] = this.intAttribute;
    }
    if (typeof this.doubleAttribute !== 'undefined') {
      toReturn['doubleAttribute'] = this.doubleAttribute;
    }
    if (typeof this.stringAttribute !== 'undefined') {
      toReturn['stringAttribute'] = this.stringAttribute;
    }
    if (typeof this.boolAttribute !== 'undefined') {
      toReturn['boolAttribute'] = this.boolAttribute;
    }
    if (typeof this.structAttribute !== 'undefined' && this.structAttribute !== null) {
      toReturn['structAttribute'] = 'toApiJson' in this.structAttribute ? this.structAttribute.toApiJson() : this.structAttribute;
    }
    if (typeof this.listAttribute !== 'undefined' && this.listAttribute !== null) {
      toReturn['listAttribute'] = 'toApiJson' in this.listAttribute ? this.listAttribute.toApiJson() : this.listAttribute;
    }
    if (typeof this.timestampAttribute !== 'undefined' && this.timestampAttribute !== null) {
      toReturn['timestampAttribute'] = 'toApiJson' in this.timestampAttribute ? this.timestampAttribute.toApiJson() : this.timestampAttribute;
    }
    if (typeof this.geopointAttribute !== 'undefined' && this.geopointAttribute !== null) {
      toReturn['geopointAttribute'] = 'toApiJson' in this.geopointAttribute ? this.geopointAttribute.toApiJson() : this.geopointAttribute;
    }
    return toReturn;
  }
}
class StructAttributeAttributesEntry {
  static fromProto(proto) {
    let m = new StructAttributeAttributesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Attribute.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GeoPointAttribute {
  static fromProto(proto) {
    let m = new GeoPointAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class ListAttribute {
  static fromProto(proto) {
    let m = new ListAttribute();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class StructAttribute {
  static fromProto(proto) {
    let m = new StructAttribute();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = Object.keys(proto.attributes).reduce((obj, k) => {
        obj[k] = Attribute.fromProto(proto.attributes[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BooleanOperator = /*#__PURE__*/function (BooleanOperator) {
  BooleanOperator[BooleanOperator["AND"] = 0] = "AND";
  BooleanOperator[BooleanOperator["OR"] = 1] = "OR";
  BooleanOperator[BooleanOperator["NOT"] = 2] = "NOT";
  return BooleanOperator;
}(BooleanOperator || {});
var ForOperator = /*#__PURE__*/function (ForOperator) {
  ForOperator[ForOperator["ANY"] = 0] = "ANY";
  ForOperator[ForOperator["ALL"] = 1] = "ALL";
  return ForOperator;
}(ForOperator || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AuxiliaryDataFieldType = /*#__PURE__*/function (AuxiliaryDataFieldType) {
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INVALID"] = 0] = "AUXILIARY_DATA_FIELD_TYPE_INVALID";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_STRING"] = 1] = "AUXILIARY_DATA_FIELD_TYPE_STRING";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INTEGER"] = 2] = "AUXILIARY_DATA_FIELD_TYPE_INTEGER";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DATE"] = 3] = "AUXILIARY_DATA_FIELD_TYPE_DATE";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DROPDOWN"] = 4] = "AUXILIARY_DATA_FIELD_TYPE_DROPDOWN";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_CURRENCY"] = 5] = "AUXILIARY_DATA_FIELD_TYPE_CURRENCY";
  return AuxiliaryDataFieldType;
}(AuxiliaryDataFieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AlgorithmType = /*#__PURE__*/function (AlgorithmType) {
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_ES256"] = 0] = "ALGORITHM_TYPE_ES256";
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_RS256"] = 1] = "ALGORITHM_TYPE_RS256";
  return AlgorithmType;
}(AlgorithmType || {});
var EmailBranding = /*#__PURE__*/function (EmailBranding) {
  EmailBranding[EmailBranding["EMAIL_BRANDING_INVALID"] = 0] = "EMAIL_BRANDING_INVALID";
  EmailBranding[EmailBranding["EMAIL_BRANDING_PARTNER"] = 1] = "EMAIL_BRANDING_PARTNER";
  EmailBranding[EmailBranding["EMAIL_BRANDING_PARENT_PARTNER"] = 2] = "EMAIL_BRANDING_PARENT_PARTNER";
  return EmailBranding;
}(EmailBranding || {});
var PhoneNumberType = /*#__PURE__*/function (PhoneNumberType) {
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_INVALID"] = 0] = "PHONE_NUMBER_TYPE_INVALID";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_WORK"] = 1] = "PHONE_NUMBER_TYPE_WORK";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_HOME"] = 2] = "PHONE_NUMBER_TYPE_HOME";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_MOBILE"] = 3] = "PHONE_NUMBER_TYPE_MOBILE";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_FAX"] = 4] = "PHONE_NUMBER_TYPE_FAX";
  PhoneNumberType[PhoneNumberType["PHONE_NUMBER_TYPE_PAGER"] = 5] = "PHONE_NUMBER_TYPE_PAGER";
  return PhoneNumberType;
}(PhoneNumberType || {});
var RestrictionType = /*#__PURE__*/function (RestrictionType) {
  RestrictionType[RestrictionType["RESTRICTION_TYPE_UNSET"] = 0] = "RESTRICTION_TYPE_UNSET";
  RestrictionType[RestrictionType["RESTRICTION_TYPE_RESET_PASSWORD_BEFORE_LOGIN"] = 1] = "RESTRICTION_TYPE_RESET_PASSWORD_BEFORE_LOGIN";
  RestrictionType[RestrictionType["RESTRICTION_TYPE_FROZEN"] = 2] = "RESTRICTION_TYPE_FROZEN";
  return RestrictionType;
}(RestrictionType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_INVALID"] = 0] = "SORT_DIRECTION_INVALID";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var UserSortField = /*#__PURE__*/function (UserSortField) {
  UserSortField[UserSortField["USER_SORT_FIELD_INVALID"] = 0] = "USER_SORT_FIELD_INVALID";
  UserSortField[UserSortField["USER_SORT_FIELD_CREATED"] = 1] = "USER_SORT_FIELD_CREATED";
  UserSortField[UserSortField["USER_SORT_FIELD_FIRST_NAME"] = 2] = "USER_SORT_FIELD_FIRST_NAME";
  UserSortField[UserSortField["USER_SORT_FIELD_LAST_NAME"] = 3] = "USER_SORT_FIELD_LAST_NAME";
  UserSortField[UserSortField["USER_SORT_FIELD_EMAIL"] = 4] = "USER_SORT_FIELD_EMAIL";
  UserSortField[UserSortField["USER_SORT_FIELD_LAST_LOGIN"] = 5] = "USER_SORT_FIELD_LAST_LOGIN";
  return UserSortField;
}(UserSortField || {});
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IfClause {
  static fromProto(proto) {
    let m = new IfClause();
    m = Object.assign(m, proto);
    if (proto.resourceAttributeValue) {
      m.resourceAttributeValue = Attribute.fromProto(proto.resourceAttributeValue);
    }
    if (proto.thenPolicy) {
      m.thenPolicy = PolicyNode.fromProto(proto.thenPolicy);
    }
    if (proto.elsePolicy) {
      m.elsePolicy = PolicyNode.fromProto(proto.elsePolicy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    if (typeof this.resourceAttributeValue !== 'undefined' && this.resourceAttributeValue !== null) {
      toReturn['resourceAttributeValue'] = 'toApiJson' in this.resourceAttributeValue ? this.resourceAttributeValue.toApiJson() : this.resourceAttributeValue;
    }
    if (typeof this.thenPolicy !== 'undefined' && this.thenPolicy !== null) {
      toReturn['thenPolicy'] = 'toApiJson' in this.thenPolicy ? this.thenPolicy.toApiJson() : this.thenPolicy;
    }
    if (typeof this.elsePolicy !== 'undefined' && this.elsePolicy !== null) {
      toReturn['elsePolicy'] = 'toApiJson' in this.elsePolicy ? this.elsePolicy.toApiJson() : this.elsePolicy;
    }
    return toReturn;
  }
}
class Operator {
  static fromProto(proto) {
    let m = new Operator();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$4(BooleanOperator, proto.operator);
    }
    if (proto.children) {
      m.children = proto.children.map(PolicyNode.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    return toReturn;
  }
}
class PolicyNode {
  static fromProto(proto) {
    let m = new PolicyNode();
    m = Object.assign(m, proto);
    if (proto.subjectResourceIntersection) {
      m.subjectResourceIntersection = SubjectResourceIntersectionClause.fromProto(proto.subjectResourceIntersection);
    }
    if (proto.operator) {
      m.operator = Operator.fromProto(proto.operator);
    }
    if (proto.subjectValueIntersection) {
      m.subjectValueIntersection = SubjectValueIntersectionClause.fromProto(proto.subjectValueIntersection);
    }
    if (proto.subjectMissingValue) {
      m.subjectMissingValue = SubjectMissingValueClause.fromProto(proto.subjectMissingValue);
    }
    if (proto.subjectResourceSubset) {
      m.subjectResourceSubset = SubjectResourceSubsetClause.fromProto(proto.subjectResourceSubset);
    }
    if (proto.subjectResourceFor) {
      m.subjectResourceFor = SubjectResourceForClause.fromProto(proto.subjectResourceFor);
    }
    if (proto.ifClause) {
      m.ifClause = IfClause.fromProto(proto.ifClause);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectResourceIntersection !== 'undefined' && this.subjectResourceIntersection !== null) {
      toReturn['subjectResourceIntersection'] = 'toApiJson' in this.subjectResourceIntersection ? this.subjectResourceIntersection.toApiJson() : this.subjectResourceIntersection;
    }
    if (typeof this.operator !== 'undefined' && this.operator !== null) {
      toReturn['operator'] = 'toApiJson' in this.operator ? this.operator.toApiJson() : this.operator;
    }
    if (typeof this.subjectValueIntersection !== 'undefined' && this.subjectValueIntersection !== null) {
      toReturn['subjectValueIntersection'] = 'toApiJson' in this.subjectValueIntersection ? this.subjectValueIntersection.toApiJson() : this.subjectValueIntersection;
    }
    if (typeof this.subjectMissingValue !== 'undefined' && this.subjectMissingValue !== null) {
      toReturn['subjectMissingValue'] = 'toApiJson' in this.subjectMissingValue ? this.subjectMissingValue.toApiJson() : this.subjectMissingValue;
    }
    if (typeof this.subjectResourceSubset !== 'undefined' && this.subjectResourceSubset !== null) {
      toReturn['subjectResourceSubset'] = 'toApiJson' in this.subjectResourceSubset ? this.subjectResourceSubset.toApiJson() : this.subjectResourceSubset;
    }
    if (typeof this.subjectResourceFor !== 'undefined' && this.subjectResourceFor !== null) {
      toReturn['subjectResourceFor'] = 'toApiJson' in this.subjectResourceFor ? this.subjectResourceFor.toApiJson() : this.subjectResourceFor;
    }
    if (typeof this.ifClause !== 'undefined' && this.ifClause !== null) {
      toReturn['ifClause'] = 'toApiJson' in this.ifClause ? this.ifClause.toApiJson() : this.ifClause;
    }
    return toReturn;
  }
}
class SubjectMissingValueClause {
  static fromProto(proto) {
    let m = new SubjectMissingValueClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    return toReturn;
  }
}
class SubjectResourceForClause {
  static fromProto(proto) {
    let m = new SubjectResourceForClause();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$4(ForOperator, proto.operator);
    }
    if (proto.rules) {
      m.rules = PolicyNode.fromProto(proto.rules);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class SubjectResourceIntersectionClause {
  static fromProto(proto) {
    let m = new SubjectResourceIntersectionClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    return toReturn;
  }
}
class SubjectResourceSubsetClause {
  static fromProto(proto) {
    let m = new SubjectResourceSubsetClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    return toReturn;
  }
}
class SubjectValueIntersectionClause {
  static fromProto(proto) {
    let m = new SubjectValueIntersectionClause();
    m = Object.assign(m, proto);
    if (proto.structuredAttributeValue) {
      m.structuredAttributeValue = Attribute.fromProto(proto.structuredAttributeValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.attributeValue !== 'undefined') {
      toReturn['attributeValue'] = this.attributeValue;
    }
    if (typeof this.structuredAttributeValue !== 'undefined' && this.structuredAttributeValue !== null) {
      toReturn['structuredAttributeValue'] = 'toApiJson' in this.structuredAttributeValue ? this.structuredAttributeValue.toApiJson() : this.structuredAttributeValue;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessCheckFailures {
  static fromProto(proto) {
    let m = new AccessCheckFailures();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.failedKeys !== 'undefined') {
      toReturn['failedKeys'] = this.failedKeys;
    }
    return toReturn;
  }
}
class AccessResourceRequest {
  static fromProto(proto) {
    let m = new AccessResourceRequest();
    m = Object.assign(m, proto);
    if (proto.resourceAttributes) {
      m.resourceAttributes = Object.keys(proto.resourceAttributes).reduce((obj, k) => {
        obj[k] = StructAttribute.fromProto(proto.resourceAttributes[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.actions !== 'undefined') {
      toReturn['actions'] = this.actions;
    }
    if (typeof this.resourceAttributes !== 'undefined' && this.resourceAttributes !== null) {
      toReturn['resourceAttributes'] = 'toApiJson' in this.resourceAttributes ? this.resourceAttributes.toApiJson() : this.resourceAttributes;
    }
    return toReturn;
  }
}
class AddClientKeyRequest {
  static fromProto(proto) {
    let m = new AddClientKeyRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.algorithmType) {
      m.algorithmType = enumStringToValue$3(AlgorithmType, proto.algorithmType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.algorithmType !== 'undefined') {
      toReturn['algorithmType'] = this.algorithmType;
    }
    return toReturn;
  }
}
class AddClientKeyResponse {
  static fromProto(proto) {
    let m = new AddClientKeyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.privateKey !== 'undefined') {
      toReturn['privateKey'] = this.privateKey;
    }
    if (typeof this.clientKeyId !== 'undefined') {
      toReturn['clientKeyId'] = this.clientKeyId;
    }
    return toReturn;
  }
}
class AddMultiUserRestrictionRequest {
  static fromProto(proto) {
    let m = new AddMultiUserRestrictionRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    if (proto.restrictionType) {
      m.restrictionType = enumStringToValue$3(RestrictionType, proto.restrictionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.restrictionType !== 'undefined') {
      toReturn['restrictionType'] = this.restrictionType;
    }
    return toReturn;
  }
}
class AddUserRoleRequest {
  static fromProto(proto) {
    let m = new AddUserRoleRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.attributes) {
      m.attributes = StructAttribute.fromProto(proto.attributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.roleId !== 'undefined') {
      toReturn['roleId'] = this.roleId;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class Address {
  static fromProto(proto) {
    let m = new Address();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.additionalAddress !== 'undefined') {
      toReturn['additionalAddress'] = this.additionalAddress;
    }
    return toReturn;
  }
}
class CallbackResourceData {
  static fromProto(proto) {
    let m = new CallbackResourceData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requiredResourceParameters !== 'undefined') {
      toReturn['requiredResourceParameters'] = this.requiredResourceParameters;
    }
    return toReturn;
  }
}
class ChangePasswordRequest {
  static fromProto(proto) {
    let m = new ChangePasswordRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.currentPassword !== 'undefined') {
      toReturn['currentPassword'] = this.currentPassword;
    }
    if (typeof this.newPassword !== 'undefined') {
      toReturn['newPassword'] = this.newPassword;
    }
    return toReturn;
  }
}
class CreateExternalIDRequest {
  static fromProto(proto) {
    let m = new CreateExternalIDRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.typedExternalIdentifier) {
      m.typedExternalIdentifier = TypedExternalIdentifier.fromProto(proto.typedExternalIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.typedExternalIdentifier !== 'undefined' && this.typedExternalIdentifier !== null) {
      toReturn['typedExternalIdentifier'] = 'toApiJson' in this.typedExternalIdentifier ? this.typedExternalIdentifier.toApiJson() : this.typedExternalIdentifier;
    }
    return toReturn;
  }
}
class CreateSessionFailure {
  static fromProto(proto) {
    let m = new CreateSessionFailure();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorCode !== 'undefined') {
      toReturn['errorCode'] = this.errorCode;
    }
    return toReturn;
  }
}
class CreateSessionRequest {
  static fromProto(proto) {
    let m = new CreateSessionRequest();
    m = Object.assign(m, proto);
    if (proto.oauthCredentials) {
      m.oauthCredentials = OAuthCredentials.fromProto(proto.oauthCredentials);
    }
    if (proto.passwordCredentials) {
      m.passwordCredentials = PasswordCredentials.fromProto(proto.passwordCredentials);
    }
    if (proto.oneTimePasswordCredentials) {
      m.oneTimePasswordCredentials = OneTimePasswordCredentials.fromProto(proto.oneTimePasswordCredentials);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.oauthCredentials !== 'undefined' && this.oauthCredentials !== null) {
      toReturn['oauthCredentials'] = 'toApiJson' in this.oauthCredentials ? this.oauthCredentials.toApiJson() : this.oauthCredentials;
    }
    if (typeof this.passwordCredentials !== 'undefined' && this.passwordCredentials !== null) {
      toReturn['passwordCredentials'] = 'toApiJson' in this.passwordCredentials ? this.passwordCredentials.toApiJson() : this.passwordCredentials;
    }
    if (typeof this.oneTimePasswordCredentials !== 'undefined' && this.oneTimePasswordCredentials !== null) {
      toReturn['oneTimePasswordCredentials'] = 'toApiJson' in this.oneTimePasswordCredentials ? this.oneTimePasswordCredentials.toApiJson() : this.oneTimePasswordCredentials;
    }
    if (typeof this.subjectTypes !== 'undefined') {
      toReturn['subjectTypes'] = this.subjectTypes;
    }
    return toReturn;
  }
}
class CreateSessionResponse {
  static fromProto(proto) {
    let m = new CreateSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    return toReturn;
  }
}
class CreateUserRequest {
  static fromProto(proto) {
    let m = new CreateUserRequest();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    if (proto.typedExternalIdentifiers) {
      m.typedExternalIdentifiers = proto.typedExternalIdentifiers.map(TypedExternalIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.typedExternalIdentifiers !== 'undefined' && this.typedExternalIdentifiers !== null) {
      toReturn['typedExternalIdentifiers'] = 'toApiJson' in this.typedExternalIdentifiers ? this.typedExternalIdentifiers.toApiJson() : this.typedExternalIdentifiers;
    }
    return toReturn;
  }
}
class CreateUserResponse {
  static fromProto(proto) {
    let m = new CreateUserResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class DeletePolicyRequest {
  static fromProto(proto) {
    let m = new DeletePolicyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.policyId !== 'undefined') {
      toReturn['policyId'] = this.policyId;
    }
    return toReturn;
  }
}
class DeleteUserRequest {
  static fromProto(proto) {
    let m = new DeleteUserRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class ExchangeClientKeyAssertionRequest {
  static fromProto(proto) {
    let m = new ExchangeClientKeyAssertionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assertion !== 'undefined') {
      toReturn['assertion'] = this.assertion;
    }
    return toReturn;
  }
}
class ExchangeClientKeyAssertionResponse {
  static fromProto(proto) {
    let m = new ExchangeClientKeyAssertionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class ListSecurityLogsRequestFilters {
  static fromProto(proto) {
    let m = new ListSecurityLogsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionId !== 'undefined') {
      toReturn['actionId'] = this.actionId;
    }
    return toReturn;
  }
}
class GetMultiExternalIDRequest {
  static fromProto(proto) {
    let m = new GetMultiExternalIDRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.externalIdType !== 'undefined') {
      toReturn['externalIdType'] = this.externalIdType;
    }
    return toReturn;
  }
}
class GetMultiExternalIDResponse {
  static fromProto(proto) {
    let m = new GetMultiExternalIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIds !== 'undefined') {
      toReturn['externalIds'] = this.externalIds;
    }
    return toReturn;
  }
}
class GetMultiUsersRequest {
  static fromProto(proto) {
    let m = new GetMultiUsersRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    if (proto.propertyMask) {
      m.propertyMask = UserPropertyMask.fromProto(proto.propertyMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.propertyMask !== 'undefined' && this.propertyMask !== null) {
      toReturn['propertyMask'] = 'toApiJson' in this.propertyMask ? this.propertyMask.toApiJson() : this.propertyMask;
    }
    return toReturn;
  }
}
class GetMultiUsersResponse {
  static fromProto(proto) {
    let m = new GetMultiUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    return toReturn;
  }
}
class GetResetPasswordTokenRequest {
  static fromProto(proto) {
    let m = new GetResetPasswordTokenRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class GetResetPasswordTokenResponse {
  static fromProto(proto) {
    let m = new GetResetPasswordTokenResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resetPasswordToken !== 'undefined') {
      toReturn['resetPasswordToken'] = this.resetPasswordToken;
    }
    return toReturn;
  }
}
class GetTokenForUserRequest {
  static fromProto(proto) {
    let m = new GetTokenForUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.refreshToken !== 'undefined') {
      toReturn['refreshToken'] = this.refreshToken;
    }
    if (typeof this.clientAssertion !== 'undefined') {
      toReturn['clientAssertion'] = this.clientAssertion;
    }
    if (typeof this.federatedIdentityProvider !== 'undefined') {
      toReturn['federatedIdentityProvider'] = this.federatedIdentityProvider;
    }
    if (typeof this.scopes !== 'undefined') {
      toReturn['scopes'] = this.scopes;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.nonce !== 'undefined') {
      toReturn['nonce'] = this.nonce;
    }
    if (typeof this.impersonateeUserId !== 'undefined') {
      toReturn['impersonateeUserId'] = this.impersonateeUserId;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.legacyUserId !== 'undefined') {
      toReturn['legacyUserId'] = this.legacyUserId;
    }
    return toReturn;
  }
}
class GetTokenForUserResponse {
  static fromProto(proto) {
    let m = new GetTokenForUserResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identityToken !== 'undefined') {
      toReturn['identityToken'] = this.identityToken;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.refreshToken !== 'undefined') {
      toReturn['refreshToken'] = this.refreshToken;
    }
    if (typeof this.oidcIdentityToken !== 'undefined') {
      toReturn['oidcIdentityToken'] = this.oidcIdentityToken;
    }
    return toReturn;
  }
}
class LinkedIn {
  static fromProto(proto) {
    let m = new LinkedIn();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publicProfileId !== 'undefined') {
      toReturn['publicProfileId'] = this.publicProfileId;
    }
    return toReturn;
  }
}
class ListResourcesRequest {
  static fromProto(proto) {
    let m = new ListResourcesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListResourcesResponse {
  static fromProto(proto) {
    let m = new ListResourcesResponse();
    m = Object.assign(m, proto);
    if (proto.resources) {
      m.resources = proto.resources.map(Resource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resources !== 'undefined' && this.resources !== null) {
      toReturn['resources'] = 'toApiJson' in this.resources ? this.resources.toApiJson() : this.resources;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListSecurityLogsRequest {
  static fromProto(proto) {
    let m = new ListSecurityLogsRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.filters) {
      m.filters = ListSecurityLogsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListSecurityLogsResponse {
  static fromProto(proto) {
    let m = new ListSecurityLogsResponse();
    m = Object.assign(m, proto);
    if (proto.logs) {
      m.logs = proto.logs.map(SecurityLog.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logs !== 'undefined' && this.logs !== null) {
      toReturn['logs'] = 'toApiJson' in this.logs ? this.logs.toApiJson() : this.logs;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListUserRolesMetadataRequest {
  static fromProto(proto) {
    let m = new ListUserRolesMetadataRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListUserRolesMetadataResponse {
  static fromProto(proto) {
    let m = new ListUserRolesMetadataResponse();
    m = Object.assign(m, proto);
    if (proto.userRoleMetadatas) {
      m.userRoleMetadatas = proto.userRoleMetadatas.map(UserRoleMetadata.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userRoleMetadatas !== 'undefined' && this.userRoleMetadatas !== null) {
      toReturn['userRoleMetadatas'] = 'toApiJson' in this.userRoleMetadatas ? this.userRoleMetadatas.toApiJson() : this.userRoleMetadatas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListUsersRequest {
  static fromProto(proto) {
    let m = new ListUsersRequest();
    m = Object.assign(m, proto);
    if (proto.userFilter) {
      m.userFilter = UserFilter.fromProto(proto.userFilter);
    }
    if (proto.propertyMask) {
      m.propertyMask = UserPropertyMask.fromProto(proto.propertyMask);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = proto.sortOptions.map(UserSortOptions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.allPartners !== 'undefined') {
      toReturn['allPartners'] = this.allPartners;
    }
    if (typeof this.userFilter !== 'undefined' && this.userFilter !== null) {
      toReturn['userFilter'] = 'toApiJson' in this.userFilter ? this.userFilter.toApiJson() : this.userFilter;
    }
    if (typeof this.propertyMask !== 'undefined' && this.propertyMask !== null) {
      toReturn['propertyMask'] = 'toApiJson' in this.propertyMask ? this.propertyMask.toApiJson() : this.propertyMask;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListUsersResponse {
  static fromProto(proto) {
    let m = new ListUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class NamespacedEmail {
  static fromProto(proto) {
    let m = new NamespacedEmail();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class OAuthCredentials {
  static fromProto(proto) {
    let m = new OAuthCredentials();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.idToken !== 'undefined') {
      toReturn['idToken'] = this.idToken;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    return toReturn;
  }
}
class OneTimePasswordCredentials {
  static fromProto(proto) {
    let m = new OneTimePasswordCredentials();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.oneTimePassword !== 'undefined') {
      toReturn['oneTimePassword'] = this.oneTimePassword;
    }
    return toReturn;
  }
}
class UpdateUserRequestOperation {
  static fromProto(proto) {
    let m = new UpdateUserRequestOperation();
    m = Object.assign(m, proto);
    if (proto.phoneNumbers) {
      m.phoneNumbers = UpdateUserRequestPhoneNumbers.fromProto(proto.phoneNumbers);
    }
    if (proto.address) {
      m.address = Address.fromProto(proto.address);
    }
    if (proto.linkedIn) {
      m.linkedIn = LinkedIn.fromProto(proto.linkedIn);
    }
    if (proto.externalId) {
      m.externalId = TypedExternalIdentifier.fromProto(proto.externalId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.greetingName !== 'undefined') {
      toReturn['greetingName'] = this.greetingName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumbers !== 'undefined' && this.phoneNumbers !== null) {
      toReturn['phoneNumbers'] = 'toApiJson' in this.phoneNumbers ? this.phoneNumbers.toApiJson() : this.phoneNumbers;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    if (typeof this.linkedIn !== 'undefined' && this.linkedIn !== null) {
      toReturn['linkedIn'] = 'toApiJson' in this.linkedIn ? this.linkedIn.toApiJson() : this.linkedIn;
    }
    if (typeof this.meetingBookingUrl !== 'undefined') {
      toReturn['meetingBookingUrl'] = this.meetingBookingUrl;
    }
    if (typeof this.externalId !== 'undefined' && this.externalId !== null) {
      toReturn['externalId'] = 'toApiJson' in this.externalId ? this.externalId.toApiJson() : this.externalId;
    }
    return toReturn;
  }
}
class UpdateUserRoleRequestOperation {
  static fromProto(proto) {
    let m = new UpdateUserRoleRequestOperation();
    m = Object.assign(m, proto);
    if (proto.replaceAttributes) {
      m.replaceAttributes = StructAttribute.fromProto(proto.replaceAttributes);
    }
    if (proto.addAttributes) {
      m.addAttributes = StructAttribute.fromProto(proto.addAttributes);
    }
    if (proto.removeAttributes) {
      m.removeAttributes = StructAttribute.fromProto(proto.removeAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dropAttributeKey !== 'undefined') {
      toReturn['dropAttributeKey'] = this.dropAttributeKey;
    }
    if (typeof this.replaceAttributes !== 'undefined' && this.replaceAttributes !== null) {
      toReturn['replaceAttributes'] = 'toApiJson' in this.replaceAttributes ? this.replaceAttributes.toApiJson() : this.replaceAttributes;
    }
    if (typeof this.addAttributes !== 'undefined' && this.addAttributes !== null) {
      toReturn['addAttributes'] = 'toApiJson' in this.addAttributes ? this.addAttributes.toApiJson() : this.addAttributes;
    }
    if (typeof this.removeAttributes !== 'undefined' && this.removeAttributes !== null) {
      toReturn['removeAttributes'] = 'toApiJson' in this.removeAttributes ? this.removeAttributes.toApiJson() : this.removeAttributes;
    }
    return toReturn;
  }
}
class PasswordCredentials {
  static fromProto(proto) {
    let m = new PasswordCredentials();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
class PhoneNumber {
  static fromProto(proto) {
    let m = new PhoneNumber();
    m = Object.assign(m, proto);
    if (proto.phoneNumberType) {
      m.phoneNumberType = enumStringToValue$3(PhoneNumberType, proto.phoneNumberType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.phoneNumberType !== 'undefined') {
      toReturn['phoneNumberType'] = this.phoneNumberType;
    }
    return toReturn;
  }
}
class UpdateUserRequestPhoneNumbers {
  static fromProto(proto) {
    let m = new UpdateUserRequestPhoneNumbers();
    m = Object.assign(m, proto);
    if (proto.phoneNumbers) {
      m.phoneNumbers = proto.phoneNumbers.map(PhoneNumber.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.phoneNumbers !== 'undefined' && this.phoneNumbers !== null) {
      toReturn['phoneNumbers'] = 'toApiJson' in this.phoneNumbers ? this.phoneNumbers.toApiJson() : this.phoneNumbers;
    }
    return toReturn;
  }
}
class ReplaceResourceRequestPoliciesEntry {
  static fromProto(proto) {
    let m = new ReplaceResourceRequestPoliciesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PolicyNode.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Policy {
  static fromProto(proto) {
    let m = new Policy();
    m = Object.assign(m, proto);
    if (proto.policy) {
      m.policy = PolicyNode.fromProto(proto.policy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.policyId !== 'undefined') {
      toReturn['policyId'] = this.policyId;
    }
    if (typeof this.policyName !== 'undefined') {
      toReturn['policyName'] = this.policyName;
    }
    if (typeof this.actions !== 'undefined') {
      toReturn['actions'] = this.actions;
    }
    if (typeof this.policy !== 'undefined' && this.policy !== null) {
      toReturn['policy'] = 'toApiJson' in this.policy ? this.policy.toApiJson() : this.policy;
    }
    if (typeof this.readOnlyPolicy !== 'undefined') {
      toReturn['readOnlyPolicy'] = this.readOnlyPolicy;
    }
    return toReturn;
  }
}
class PublicKey {
  static fromProto(proto) {
    let m = new PublicKey();
    m = Object.assign(m, proto);
    if (proto.algorithmType) {
      m.algorithmType = enumStringToValue$3(AlgorithmType, proto.algorithmType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.algorithmType !== 'undefined') {
      toReturn['algorithmType'] = this.algorithmType;
    }
    return toReturn;
  }
}
class RegisterPolicyRequest {
  static fromProto(proto) {
    let m = new RegisterPolicyRequest();
    m = Object.assign(m, proto);
    if (proto.policy) {
      m.policy = Policy.fromProto(proto.policy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.policy !== 'undefined' && this.policy !== null) {
      toReturn['policy'] = 'toApiJson' in this.policy ? this.policy.toApiJson() : this.policy;
    }
    return toReturn;
  }
}
class RegisterResourceOwnerRequest {
  static fromProto(proto) {
    let m = new RegisterResourceOwnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.appName !== 'undefined') {
      toReturn['appName'] = this.appName;
    }
    return toReturn;
  }
}
class RegisterResourceRequest {
  static fromProto(proto) {
    let m = new RegisterResourceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    return toReturn;
  }
}
class RegisterUserRoleMetadataRequest {
  static fromProto(proto) {
    let m = new RegisterUserRoleMetadataRequest();
    m = Object.assign(m, proto);
    if (proto.userRoleMetadata) {
      m.userRoleMetadata = UserRoleMetadata.fromProto(proto.userRoleMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userRoleMetadata !== 'undefined' && this.userRoleMetadata !== null) {
      toReturn['userRoleMetadata'] = 'toApiJson' in this.userRoleMetadata ? this.userRoleMetadata.toApiJson() : this.userRoleMetadata;
    }
    return toReturn;
  }
}
class RemoveClientKeyRequest {
  static fromProto(proto) {
    let m = new RemoveClientKeyRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.clientKeyId !== 'undefined') {
      toReturn['clientKeyId'] = this.clientKeyId;
    }
    return toReturn;
  }
}
class RemoveMultiUserRestrictionRequest {
  static fromProto(proto) {
    let m = new RemoveMultiUserRestrictionRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    if (proto.restrictionType) {
      m.restrictionType = enumStringToValue$3(RestrictionType, proto.restrictionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.restrictionType !== 'undefined') {
      toReturn['restrictionType'] = this.restrictionType;
    }
    return toReturn;
  }
}
class RemoveUserRoleRequest {
  static fromProto(proto) {
    let m = new RemoveUserRoleRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.roleId !== 'undefined') {
      toReturn['roleId'] = this.roleId;
    }
    return toReturn;
  }
}
class ReplaceResourceRequest {
  static fromProto(proto) {
    let m = new ReplaceResourceRequest();
    m = Object.assign(m, proto);
    if (proto.policies) {
      m.policies = Object.keys(proto.policies).reduce((obj, k) => {
        obj[k] = PolicyNode.fromProto(proto.policies[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.resourceKind !== 'undefined') {
      toReturn['resourceKind'] = this.resourceKind;
    }
    if (typeof this.resourceDescription !== 'undefined') {
      toReturn['resourceDescription'] = this.resourceDescription;
    }
    if (typeof this.policies !== 'undefined' && this.policies !== null) {
      toReturn['policies'] = 'toApiJson' in this.policies ? this.policies.toApiJson() : this.policies;
    }
    return toReturn;
  }
}
class ResetPasswordRequest {
  static fromProto(proto) {
    let m = new ResetPasswordRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resetPasswordToken !== 'undefined') {
      toReturn['resetPasswordToken'] = this.resetPasswordToken;
    }
    if (typeof this.newPassword !== 'undefined') {
      toReturn['newPassword'] = this.newPassword;
    }
    if (typeof this.invalidateActiveSessions !== 'undefined') {
      toReturn['invalidateActiveSessions'] = this.invalidateActiveSessions;
    }
    return toReturn;
  }
}
class Resource {
  static fromProto(proto) {
    let m = new Resource();
    m = Object.assign(m, proto);
    if (proto.callbackResourceData) {
      m.callbackResourceData = CallbackResourceData.fromProto(proto.callbackResourceData);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.policies) {
      m.policies = proto.policies.map(Policy.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.vstoreLink !== 'undefined') {
      toReturn['vstoreLink'] = this.vstoreLink;
    }
    if (typeof this.callbackResourceData !== 'undefined' && this.callbackResourceData !== null) {
      toReturn['callbackResourceData'] = 'toApiJson' in this.callbackResourceData ? this.callbackResourceData.toApiJson() : this.callbackResourceData;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.policies !== 'undefined' && this.policies !== null) {
      toReturn['policies'] = 'toApiJson' in this.policies ? this.policies.toApiJson() : this.policies;
    }
    if (typeof this.supportedRoleTypes !== 'undefined') {
      toReturn['supportedRoleTypes'] = this.supportedRoleTypes;
    }
    return toReturn;
  }
}
class AccessResourceRequestResourceAttributesEntry {
  static fromProto(proto) {
    let m = new AccessResourceRequestResourceAttributesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = StructAttribute.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UserRolesEntry {
  static fromProto(proto) {
    let m = new UserRolesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = UserRole.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class SecurityLog {
  static fromProto(proto) {
    let m = new SecurityLog();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.actionId !== 'undefined') {
      toReturn['actionId'] = this.actionId;
    }
    if (typeof this.logId !== 'undefined') {
      toReturn['logId'] = this.logId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class SendEmailVerificationRequest {
  static fromProto(proto) {
    let m = new SendEmailVerificationRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    if (typeof this.nextUrlButtonText !== 'undefined') {
      toReturn['nextUrlButtonText'] = this.nextUrlButtonText;
    }
    if (typeof this.forceEmailBrandingPartnerId !== 'undefined') {
      toReturn['forceEmailBrandingPartnerId'] = this.forceEmailBrandingPartnerId;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    return toReturn;
  }
}
class SendOneTimePasswordEmailRequest {
  static fromProto(proto) {
    let m = new SendOneTimePasswordEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.parameters !== 'undefined') {
      toReturn['parameters'] = this.parameters;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    if (typeof this.nextUrlButtonText !== 'undefined') {
      toReturn['nextUrlButtonText'] = this.nextUrlButtonText;
    }
    return toReturn;
  }
}
class TypedExternalIdentifier {
  static fromProto(proto) {
    let m = new TypedExternalIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIdType !== 'undefined') {
      toReturn['externalIdType'] = this.externalIdType;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class UpdateUserRequest {
  static fromProto(proto) {
    let m = new UpdateUserRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateUserRequestOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}
class UpdateUserRoleRequest {
  static fromProto(proto) {
    let m = new UpdateUserRoleRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateUserRoleRequestOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.roleId !== 'undefined') {
      toReturn['roleId'] = this.roleId;
    }
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}
class UpsertExternalIDRequest {
  static fromProto(proto) {
    let m = new UpsertExternalIDRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.typedExternalIdentifier) {
      m.typedExternalIdentifier = TypedExternalIdentifier.fromProto(proto.typedExternalIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.typedExternalIdentifier !== 'undefined' && this.typedExternalIdentifier !== null) {
      toReturn['typedExternalIdentifier'] = 'toApiJson' in this.typedExternalIdentifier ? this.typedExternalIdentifier.toApiJson() : this.typedExternalIdentifier;
    }
    return toReturn;
  }
}
class UpsertPartnerLimitsRequest {
  static fromProto(proto) {
    let m = new UpsertPartnerLimitsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.limitsId !== 'undefined') {
      toReturn['limitsId'] = this.limitsId;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.roles) {
      m.roles = Object.keys(proto.roles).reduce((obj, k) => {
        obj[k] = UserRole.fromProto(proto.roles[k]);
        return obj;
      }, {});
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.publicKeys) {
      m.publicKeys = proto.publicKeys.map(PublicKey.fromProto);
    }
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    if (proto.phoneNumbers) {
      m.phoneNumbers = proto.phoneNumbers.map(PhoneNumber.fromProto);
    }
    if (proto.address) {
      m.address = Address.fromProto(proto.address);
    }
    if (proto.linkedIn) {
      m.linkedIn = LinkedIn.fromProto(proto.linkedIn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.roles !== 'undefined' && this.roles !== null) {
      toReturn['roles'] = 'toApiJson' in this.roles ? this.roles.toApiJson() : this.roles;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.greetingName !== 'undefined') {
      toReturn['greetingName'] = this.greetingName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    if (typeof this.publicKeys !== 'undefined' && this.publicKeys !== null) {
      toReturn['publicKeys'] = 'toApiJson' in this.publicKeys ? this.publicKeys.toApiJson() : this.publicKeys;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.emailVerified !== 'undefined') {
      toReturn['emailVerified'] = this.emailVerified;
    }
    if (typeof this.phoneNumbers !== 'undefined' && this.phoneNumbers !== null) {
      toReturn['phoneNumbers'] = 'toApiJson' in this.phoneNumbers ? this.phoneNumbers.toApiJson() : this.phoneNumbers;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    if (typeof this.userSpecifiedPassword !== 'undefined') {
      toReturn['userSpecifiedPassword'] = this.userSpecifiedPassword;
    }
    if (typeof this.linkedIn !== 'undefined' && this.linkedIn !== null) {
      toReturn['linkedIn'] = 'toApiJson' in this.linkedIn ? this.linkedIn.toApiJson() : this.linkedIn;
    }
    if (typeof this.meetingBookingUrl !== 'undefined') {
      toReturn['meetingBookingUrl'] = this.meetingBookingUrl;
    }
    return toReturn;
  }
}
class UserFilter {
  static fromProto(proto) {
    let m = new UserFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.roleIds !== 'undefined') {
      toReturn['roleIds'] = this.roleIds;
    }
    if (typeof this.searchTerms !== 'undefined') {
      toReturn['searchTerms'] = this.searchTerms;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.emailVerified !== 'undefined') {
      toReturn['emailVerified'] = this.emailVerified;
    }
    return toReturn;
  }
}
class UserIdentifier {
  static fromProto(proto) {
    let m = new UserIdentifier();
    m = Object.assign(m, proto);
    if (proto.namespacedEmail) {
      m.namespacedEmail = NamespacedEmail.fromProto(proto.namespacedEmail);
    }
    if (proto.typedExternalIdentifier) {
      m.typedExternalIdentifier = TypedExternalIdentifier.fromProto(proto.typedExternalIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.namespacedEmail !== 'undefined' && this.namespacedEmail !== null) {
      toReturn['namespacedEmail'] = 'toApiJson' in this.namespacedEmail ? this.namespacedEmail.toApiJson() : this.namespacedEmail;
    }
    if (typeof this.typedExternalIdentifier !== 'undefined' && this.typedExternalIdentifier !== null) {
      toReturn['typedExternalIdentifier'] = 'toApiJson' in this.typedExternalIdentifier ? this.typedExternalIdentifier.toApiJson() : this.typedExternalIdentifier;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class UserPropertyMask {
  static fromProto(proto) {
    let m = new UserPropertyMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeRoles !== 'undefined') {
      toReturn['includeRoles'] = this.includeRoles;
    }
    return toReturn;
  }
}
class UserRole {
  static fromProto(proto) {
    let m = new UserRole();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = StructAttribute.fromProto(proto.attributes);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.roleId !== 'undefined') {
      toReturn['roleId'] = this.roleId;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class UserRoleMetadata {
  static fromProto(proto) {
    let m = new UserRoleMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.roleId !== 'undefined') {
      toReturn['roleId'] = this.roleId;
    }
    if (typeof this.ownerUserId !== 'undefined') {
      toReturn['ownerUserId'] = this.ownerUserId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UserSortOptions {
  static fromProto(proto) {
    let m = new UserSortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$3(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$3(UserSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class VerifyEmailRequest {
  static fromProto(proto) {
    let m = new VerifyEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.requestOtpCode !== 'undefined') {
      toReturn['requestOtpCode'] = this.requestOtpCode;
    }
    return toReturn;
  }
}
class VerifyEmailResponse {
  static fromProto(proto) {
    let m = new VerifyEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.otpCode !== 'undefined') {
      toReturn['otpCode'] = this.otpCode;
    }
    return toReturn;
  }
}
function userIdUserIdentifier(userId) {
  return new UserIdentifier({
    userId: userId
  });
}
function tokenUserIdentifier(token) {
  return new UserIdentifier({
    token: token
  });
}
function namespacedEmailUserIdentifier(namespace, email) {
  return new UserIdentifier({
    namespacedEmail: new NamespacedEmail({
      namespace: namespace,
      email: email
    })
  });
}
function typedExternalUserIdentifier(externalIdType, externalId) {
  return new UserIdentifier({
    typedExternalIdentifier: new TypedExternalIdentifier({
      externalIdType: externalIdType,
      externalId: externalId
    })
  });
}
function subjectIdUserIdentifier(subjectId) {
  return new UserIdentifier({
    subjectId: subjectId
  });
}

// SetFirstName .
function SetFirstName(firstName) {
  return new UpdateUserRequestOperation({
    firstName: firstName
  });
}
// SetGreetingName .
function SetGreetingName(greetingName) {
  return new UpdateUserRequestOperation({
    greetingName: greetingName
  });
}
// SetLastName .
function SetLastName(lastName) {
  return new UpdateUserRequestOperation({
    lastName: lastName
  });
}
// SetLanguageCode .
function SetLanguageCode(languageCode) {
  return new UpdateUserRequestOperation({
    languageCode: languageCode
  });
}
// SetEmail .
function SetEmail(email) {
  return new UpdateUserRequestOperation({
    email: email
  });
}
// SetPhoneNumbers .
function SetPhoneNumbers(phoneNumbers) {
  return new UpdateUserRequestOperation({
    phoneNumbers: new UpdateUserRequestPhoneNumbers({
      phoneNumbers: phoneNumbers
    })
  });
}
// SetAddress .
function SetAddress(address) {
  return new UpdateUserRequestOperation({
    address: new Address(address)
  });
}
// SetProfileImageUrl .
function SetProfileImageUrl(profileImageUrl) {
  return new UpdateUserRequestOperation({
    profileImageUrl: profileImageUrl
  });
}
// SetTimeZone .
function SetTimeZone(timeZone) {
  return new UpdateUserRequestOperation({
    timeZone: timeZone
  });
}
// SetLinkedIn .
function SetLinkedIn(linkedIn) {
  return new UpdateUserRequestOperation({
    linkedIn: new LinkedIn(linkedIn)
  });
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class AuxiliaryDataFieldSchema {
  static fromProto(proto) {
    let m = new AuxiliaryDataFieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue(AuxiliaryDataFieldType, proto.fieldType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class AuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new AuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.objectId !== 'undefined') {
      toReturn['objectId'] = this.objectId;
    }
    return toReturn;
  }
}
class CreateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldDataUpsertOperation {
  static fromProto(proto) {
    let m = new FieldDataUpsertOperation();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.currencyValue) {
      m.currencyValue = parseInt(proto.currencyValue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldDataId !== 'undefined') {
      toReturn['fieldDataId'] = this.fieldDataId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dropdownValue !== 'undefined') {
      toReturn['dropdownValue'] = this.dropdownValue;
    }
    if (typeof this.currencyValue !== 'undefined') {
      toReturn['currencyValue'] = this.currencyValue;
    }
    if (typeof this.deleteValue !== 'undefined') {
      toReturn['deleteValue'] = this.deleteValue;
    }
    return toReturn;
  }
}
class FieldSchemaIdentifier {
  static fromProto(proto) {
    let m = new FieldSchemaIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(FieldSchemaIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAuxiliaryDataFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class UpdateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'iam.vendasta-local.com',
  'test': '',
  'demo': 'iam-api-demo.apigateway.co',
  'prod': 'iam-api-prod.apigateway.co',
  'production': 'iam-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let IAMApiService = /*#__PURE__*/(() => {
  class IAMApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiUsers(r) {
      const request = r.toApiJson ? r : new GetMultiUsersRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/GetMultiUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiUsersResponse.fromProto(resp)));
    }
    listUsers(r) {
      const request = r.toApiJson ? r : new ListUsersRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ListUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersResponse.fromProto(resp)));
    }
    updateUser(r) {
      const request = r.toApiJson ? r : new UpdateUserRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/UpdateUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteUser(r) {
      const request = r.toApiJson ? r : new DeleteUserRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/DeleteUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addClientKey(r) {
      const request = r.toApiJson ? r : new AddClientKeyRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/AddClientKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddClientKeyResponse.fromProto(resp)));
    }
    removeClientKey(r) {
      const request = r.toApiJson ? r : new RemoveClientKeyRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/RemoveClientKey", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resetPassword(r) {
      const request = r.toApiJson ? r : new ResetPasswordRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ResetPassword", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listSecurityLogs(r) {
      const request = r.toApiJson ? r : new ListSecurityLogsRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ListSecurityLogs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSecurityLogsResponse.fromProto(resp)));
    }
    accessResource(r) {
      const request = r.toApiJson ? r : new AccessResourceRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/AccessResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    exchangeClientKeyAssertion(r) {
      const request = r.toApiJson ? r : new ExchangeClientKeyAssertionRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ExchangeClientKeyAssertion", request.toApiJson(), this.apiOptions()).pipe(map(resp => ExchangeClientKeyAssertionResponse.fromProto(resp)));
    }
    verifyEmail(r) {
      const request = r.toApiJson ? r : new VerifyEmailRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/VerifyEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyEmailResponse.fromProto(resp)));
    }
    sendEmailVerification(r) {
      const request = r.toApiJson ? r : new SendEmailVerificationRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/SendEmailVerification", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendOneTimePasswordEmail(r) {
      const request = r.toApiJson ? r : new SendOneTimePasswordEmailRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/SendOneTimePasswordEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiExternalId(r) {
      const request = r.toApiJson ? r : new GetMultiExternalIDRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/GetMultiExternalID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiExternalIDResponse.fromProto(resp)));
    }
    createExternalId(r) {
      const request = r.toApiJson ? r : new CreateExternalIDRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/CreateExternalID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertExternalId(r) {
      const request = r.toApiJson ? r : new UpsertExternalIDRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/UpsertExternalID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addMultiUserRestriction(r) {
      const request = r.toApiJson ? r : new AddMultiUserRestrictionRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/AddMultiUserRestriction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeMultiUserRestriction(r) {
      const request = r.toApiJson ? r : new RemoveMultiUserRestrictionRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/RemoveMultiUserRestriction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changePassword(r) {
      const request = r.toApiJson ? r : new ChangePasswordRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ChangePassword", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listUserAuxiliaryData(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ListUserAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataResponse.fromProto(resp)));
    }
    upsertUserAuxiliaryData(r) {
      const request = r.toApiJson ? r : new UpsertAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/UpsertUserAuxiliaryData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/CreateUserAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/GetUserAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    getMultiUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/GetMultiUserAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    listUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ListUserAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    updateUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/UpdateUserAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/ArchiveUserAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveUserAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/iam.v2.IAM/UnarchiveUserAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  IAMApiService.ɵfac = function IAMApiService_Factory(t) {
    return new (t || IAMApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IAMApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMApiService,
    factory: IAMApiService.ɵfac,
    providedIn: 'root'
  });
  return IAMApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function addressFromProto(address) {
  if (!address) {
    return new Address$1({});
  }
  return new Address$1({
    address: address.address,
    city: address.city,
    country: address.country,
    postalCode: address.postalCode,
    state: address.state,
    additionalAddress: address.additionalAddress
  });
}
function phoneNumberTypeFromProto(phoneNumberType) {
  switch (phoneNumberType) {
    case undefined:
    case PhoneNumberType.PHONE_NUMBER_TYPE_INVALID:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_INVALID;
      }
    case PhoneNumberType.PHONE_NUMBER_TYPE_WORK:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_WORK;
      }
    case PhoneNumberType.PHONE_NUMBER_TYPE_HOME:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_HOME;
      }
    case PhoneNumberType.PHONE_NUMBER_TYPE_MOBILE:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_MOBILE;
      }
    case PhoneNumberType.PHONE_NUMBER_TYPE_FAX:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_FAX;
      }
    case PhoneNumberType.PHONE_NUMBER_TYPE_PAGER:
      {
        return PhoneNumberType$1.PHONE_NUMBER_TYPE_PAGER;
      }
    default:
      {
        /* eslint-disable  @typescript-eslint/restrict-template-expressions */
        throw new Error(`Invalid Phone Number Type: ${phoneNumberType}`);
      }
  }
}
function phoneNumberFromProto(phoneNumber) {
  if (!phoneNumber) {
    return new PhoneNumber$1({});
  }
  const phoneNumberType = phoneNumberTypeFromProto(phoneNumber.phoneNumberType);
  return new PhoneNumber$1({
    phoneNumber: phoneNumber.phoneNumber,
    phoneNumberType: phoneNumberType
  });
}
function phoneNumbersFromProto(phoneNumbers) {
  if (!phoneNumbers) {
    return [];
  }
  const result = [];
  phoneNumbers.forEach(phoneNumber => {
    if (!phoneNumber || !phoneNumber?.phoneNumber) {
      return;
    }
    result.push(phoneNumberFromProto(phoneNumber));
  });
  return result;
}
function algorithmTypeFromProto(algorithmType) {
  switch (algorithmType) {
    case undefined:
    case AlgorithmType.ALGORITHM_TYPE_ES256:
      {
        return AlgorithmType$1.ALGORITHM_TYPE_ES256;
      }
    case AlgorithmType.ALGORITHM_TYPE_RS256:
      {
        return AlgorithmType$1.ALGORITHM_TYPE_RS256;
      }
    default:
      {
        /* eslint-disable  @typescript-eslint/restrict-template-expressions */
        throw new Error(`Invalid Algorithm Type: ${algorithmType}`);
      }
  }
}
function publicKeyFromProto(publicKey) {
  if (!publicKey) {
    return new PublicKey$1({});
  }
  const algorithmType = algorithmTypeFromProto(publicKey.algorithmType);
  return new PublicKey$1({
    algorithmType: algorithmType,
    id: publicKey.id,
    key: publicKey.key
  });
}
function publicKeysFromProto(publicKeys) {
  if (!publicKeys) {
    return [];
  }
  const result = [];
  publicKeys.forEach(publicKey => {
    if (!publicKey || !publicKey?.id || !publicKey?.key) {
      return;
    }
    result.push(publicKeyFromProto(publicKey));
  });
  return result;
}
function roleFromProto(role) {
  if (!role) {
    return new Role({});
  }
  return new Role({
    attributes: role.attributes,
    created: role.created,
    roleId: role.roleId,
    updated: role.updated
  });
}
function roleMapFromProto(roleMap) {
  if (!roleMap) {
    return {};
  }
  const map = {};
  for (const [key, role] of Object.entries(roleMap)) {
    map[key] = roleFromProto(role);
  }
  return map;
}
function linkedInFromProto(linkedIn) {
  if (!linkedIn) {
    return new LinkedIn$1({});
  }
  return new LinkedIn$1({
    publicProfileId: linkedIn.publicProfileId
  });
}
function userFromProto(user) {
  if (!user) {
    return new User$1({});
  }
  return new User$1({
    address: addressFromProto(user.address),
    created: user.created,
    email: user.email,
    emailVerified: user.emailVerified,
    firstName: user.firstName,
    greetingName: user.greetingName,
    languageCode: user.languageCode,
    lastLogin: user.lastLogin,
    lastName: user.lastName,
    linkedIn: linkedInFromProto(user.linkedIn),
    partnerId: user.partnerId,
    phoneNumbers: phoneNumbersFromProto(user.phoneNumbers),
    profileImageUrl: user.profileImageUrl,
    publicKeys: publicKeysFromProto(user.publicKeys),
    roles: roleMapFromProto(user.roles),
    timeZone: user.timeZone,
    updated: user.updated,
    userId: user.userId,
    meetingBookingUrl: user.meetingBookingUrl
  });
}
function usersFromProto(users) {
  if (!users) {
    return [];
  }
  return users.map(user => userFromProto(user));
}

// *********************************
let IAMAdminApiService = /*#__PURE__*/(() => {
  class IAMAdminApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createUser(r) {
      const request = r.toApiJson ? r : new CreateUserRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/CreateUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateUserResponse.fromProto(resp)));
    }
    getResetPasswordToken(r) {
      const request = r.toApiJson ? r : new GetResetPasswordTokenRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/GetResetPasswordToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResetPasswordTokenResponse.fromProto(resp)));
    }
    registerUserRoleMetadata(r) {
      const request = r.toApiJson ? r : new RegisterUserRoleMetadataRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/RegisterUserRoleMetadata", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listUserRolesMetadata(r) {
      const request = r.toApiJson ? r : new ListUserRolesMetadataRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/ListUserRolesMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUserRolesMetadataResponse.fromProto(resp)));
    }
    addUserRole(r) {
      const request = r.toApiJson ? r : new AddUserRoleRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/AddUserRole", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateUserRole(r) {
      const request = r.toApiJson ? r : new UpdateUserRoleRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/UpdateUserRole", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeUserRole(r) {
      const request = r.toApiJson ? r : new RemoveUserRoleRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/RemoveUserRole", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerResourceOwner(r) {
      const request = r.toApiJson ? r : new RegisterResourceOwnerRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/RegisterResourceOwner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerResource(r) {
      const request = r.toApiJson ? r : new RegisterResourceRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/RegisterResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceResource(r) {
      const request = r.toApiJson ? r : new ReplaceResourceRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/ReplaceResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerPolicy(r) {
      const request = r.toApiJson ? r : new RegisterPolicyRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/RegisterPolicy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deletePolicy(r) {
      const request = r.toApiJson ? r : new DeletePolicyRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/DeletePolicy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertPartnerLimits(r) {
      const request = r.toApiJson ? r : new UpsertPartnerLimitsRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/UpsertPartnerLimits", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createSession(r) {
      const request = r.toApiJson ? r : new CreateSessionRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/CreateSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSessionResponse.fromProto(resp)));
    }
    listResources(r) {
      const request = r.toApiJson ? r : new ListResourcesRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMAdmin/ListResources", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListResourcesResponse.fromProto(resp)));
    }
  }
  IAMAdminApiService.ɵfac = function IAMAdminApiService_Factory(t) {
    return new (t || IAMAdminApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IAMAdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMAdminApiService,
    factory: IAMAdminApiService.ɵfac,
    providedIn: 'root'
  });
  return IAMAdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let IAMSSOApiService = /*#__PURE__*/(() => {
  class IAMSSOApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTokenForUser(r) {
      const request = r.toApiJson ? r : new GetTokenForUserRequest(r);
      return this.http.post(this._host + "/iam.v2.IAMSSO/GetTokenForUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTokenForUserResponse.fromProto(resp)));
    }
  }
  IAMSSOApiService.ɵfac = function IAMSSOApiService_Factory(t) {
    return new (t || IAMSSOApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IAMSSOApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMSSOApiService,
    factory: IAMSSOApiService.ɵfac,
    providedIn: 'root'
  });
  return IAMSSOApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let IAMService = /*#__PURE__*/(() => {
  class IAMService {
    constructor(api, admin) {
      this.api = api;
      this.admin = admin;
    }
    // getUser fetches a single user by their identifier.
    // Example usage: iam.getUser(userIdUserIdentifier("U-123"))
    getUser(userIdentifier) {
      return this.getMultiUsers([userIdentifier]).pipe(map(users => users[0]));
    }
    // getMultiUsers fetches multiple users by their identifiers.
    // Example usage: iam.getMultiUsers([userIdUserIdentifier("U-123"), subjectIdUserIdentifier("UID-321")])
    getMultiUsers(userIdentifiers) {
      return this.api.getMultiUsers({
        userIdentifiers: userIdentifiers,
        // This property mask technically does nothing in the backend at the moment...
        propertyMask: new UserPropertyMask({
          includeRoles: true
        })
      }).pipe(map(r => {
        return usersFromProto(r.users);
      }));
    }
    // updateUser updates the values stored on a user
    // Example usage: iam.updateUser(userIdUserIdentifier("U-123"), [
    //   SetFirstName("Example"),
    //   SetAddress({
    //     address: "410 22 St E",
    //     city: "Saskatoon",
    //     postalCode: "S7K 5T6",
    //     country: "CA",
    //     state: "CA-SK",
    //   }),
    // ]);
    updateUser(userIdentifier, mutations) {
      return this.api.updateUser({
        userIdentifier: userIdentifier,
        operations: mutations
      });
    }
    // deleteUser deletes the user
    // Example usage: iam.deleteUser(userIdUserIdentifier("U-123")
    deleteUser(userIdentifier) {
      return this.api.deleteUser({
        userIdentifier: userIdentifier
      });
    }
    // changePassword uses the user's current password to change their password to the new password
    // Example usage: iam.changePassword(userIdUserIdentifier("U-123"), "mypassword", "mynewpassword");
    changePassword(userIdentifier, currentPassword, newPassword) {
      return this.api.changePassword({
        userIdentifier: userIdentifier,
        currentPassword: currentPassword,
        newPassword: newPassword
      });
    }
    // sendEmailVerification sends an email to the user to verify ownership of their email
    // recaptchaToken is required when calling without an authToken
    // Example usage: iam.sendEmailVerification(userIdUserIdentifier("U-123"), EMAIL_BRANDING_PARTNER, "www.domain.com", "Go Here", recaptchaToken);
    sendEmailVerification(userIdentifier, forceEmailBrandingPartnerId, nextUrl, nextUrlButtonText, recaptchaToken) {
      return this.api.sendEmailVerification({
        userIdentifier: userIdentifier,
        forceEmailBrandingPartnerId: forceEmailBrandingPartnerId,
        nextUrl: nextUrl,
        nextUrlButtonText: nextUrlButtonText,
        recaptchaToken: recaptchaToken
      });
    }
    // verifyEmail attempts to verify the email for the user contained in the verification token
    // If the token was expired, the call will fail, and the email verification will be resent
    // If an OTP code was requested it will be returned if the user is newly verified
    verifyEmail(emailVerificationToken, requestOtpCode) {
      return this.api.verifyEmail({
        token: emailVerificationToken,
        requestOtpCode: requestOtpCode
      });
    }
    listUserAuxiliaryData(auxiliaryDataObjectId, pagingOptions) {
      return this.api.listUserAuxiliaryData({
        auxiliaryDataObjectId,
        pagingOptions
      });
    }
    upsertUserAuxiliaryData(auxiliaryDataObjectId, fieldDataUpsertOperations) {
      return this.api.upsertUserAuxiliaryData({
        auxiliaryDataObjectId,
        fieldDataUpsertOperations
      });
    }
    createUserAuxiliaryDataFieldSchema(fieldSchema) {
      return this.api.createUserAuxiliaryDataFieldSchema({
        fieldSchema
      });
    }
    getUserAuxiliaryDataFieldSchema(identifier) {
      return this.api.getUserAuxiliaryDataFieldSchema({
        identifier: identifier
      });
    }
    getMultiUserAuxiliaryDataFieldSchema(fieldSchemaIdentifiers) {
      return this.api.getMultiUserAuxiliaryDataFieldSchema({
        identifiers: fieldSchemaIdentifiers
      });
    }
    listUserAuxiliaryDataFieldSchema(partnerId, pagingOptions, filters) {
      return this.api.listUserAuxiliaryDataFieldSchema({
        partnerId,
        pagingOptions,
        filters
      });
    }
    updateUserAuxiliaryDataFieldSchema(fieldSchema, fieldMask) {
      return this.api.updateUserAuxiliaryDataFieldSchema({
        fieldSchema,
        fieldMask
      });
    }
    archiveUserAuxiliaryDataFieldSchema(identifier) {
      return this.api.archiveUserAuxiliaryDataFieldSchema({
        identifier: identifier
      });
    }
    unarchiveUserAuxiliaryDataFieldSchema(identifier) {
      return this.api.unarchiveUserAuxiliaryDataFieldSchema({
        identifier: identifier
      });
    }
    listResources(cursor, pageSize) {
      return this.admin.listResources({
        cursor: cursor,
        pageSize: pageSize
      });
    }
  }
  IAMService.ɵfac = function IAMService_Factory(t) {
    return new (t || IAMService)(i0.ɵɵinject(IAMApiService), i0.ɵɵinject(IAMAdminApiService));
  };
  IAMService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMService,
    factory: IAMService.ɵfac,
    providedIn: 'root'
  });
  return IAMService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// parseTokenInsecure parses the payload from the token and returns the data
// Note: parseTokenInsecure does not verify the validity of the token, only extracts the data contained inside.
// Note: You may use this to make assumptions about the active user, but ensure that your endpoints are still performing
//  reasonable access checks, and your application has performed any recommended token validation (ex. during OpenID)
function parseTokenInsecure(token) {
  const decoded = jwt_decode(token);
  if (!decoded) {
    return null;
  }
  const userId = decoded?.user_id || '';
  const impersonateeUserId = decoded?.impersonatee;
  return {
    userId: userId,
    impersonateeUserId: impersonateeUserId
  };
}

/**
 * Generated bundle index. Do not edit.
 */

export { Address$1 as Address, AlgorithmType$1 as AlgorithmType, AuxiliaryDataFieldType, FieldMask, GetAuxiliaryDataFieldSchemaResponse, IAMService, LinkedIn$1 as LinkedIn, ListAuxiliaryDataFieldSchemaResponse, ListAuxiliaryDataResponse, PagedRequestOptions, PagedResponseMetadata, PhoneNumber$1 as PhoneNumber, PhoneNumberType$1 as PhoneNumberType, PublicKey$1 as PublicKey, Role, SetAddress, SetEmail, SetFirstName, SetGreetingName, SetLanguageCode, SetLastName, SetLinkedIn, SetPhoneNumbers, SetProfileImageUrl, SetTimeZone, StructAttribute, UpdateUserRequestOperation, User$1 as User, UserIdentifier, namespacedEmailUserIdentifier, parseTokenInsecure, subjectIdUserIdentifier, tokenUserIdentifier, typedExternalUserIdentifier, userIdUserIdentifier };
